import { MappedUserProfileFieldDefinition } from 'models/user/userProfileField/definition/MappedUserProfileFieldDefinition';

export class MappedUserProfileFieldDefinitionService {
	toModel(definition) {
		return new MappedUserProfileFieldDefinition(definition);
	}
}
